export const homeVideoStory = {
  beauty: {
    src: "/videos/home-filming-luxury-beauty-product.mp4",
    poster: "/videos/previews/beauty-film.webp",
    title: "Beauty product film",
  },
  cosmetics: {
    src: "/videos/home-luxury-cosmetic-advertising.mp4",
    poster: "/videos/previews/cosmetics-film.webp",
    title: "Luxury cosmetics film",
  },
  motion: {
    src: "/videos/video-editing-ai-motion-synthesis.mp4",
    poster: "/videos/previews/fashion-motion.webp",
    title: "Fashion motion study",
  },
} as const;
